import { useModal } from 'modals';
import { ReactNode } from 'react';

import '@cartwhl/ui/utilities/FrostedGlass.css';

interface ContentButtonProps {
  children?: ReactNode;
  comingSoon?: boolean;
  comingSoonText?: string;
  excitedAbout?: string;
  className?: string;
}

export default function ContentButton({
  children,
  comingSoon = false,
  comingSoonText = 'Coming soon',
  excitedAbout,
  className,
}: ContentButtonProps) {
  const { open } = useModal();

  return (
    <div
      className={`relative inline-flex h-10 items-center ${
        comingSoon ? 'gap-2 rounded-[12px] pl-4 pr-[5px]' : 'rounded-lg px-4'
      } ${className ?? ''}`}
    >
      {/* Frosted glass background */}
      <div
        className={`frosted-glass dark:bg-gray-90/50 absolute inset-0 rounded-[inherit] bg-white/60 backdrop-blur-3xl backdrop-saturate-[1.8] transition-colors ${
          comingSoon
            ? 'bg-white/60'
            : 'dark:group-hover:bg-gray-90 group-hover:bg-white'
        }`}
      >
        <div
          className="dark:from-gray-90/40 dark:to-gray-90/20 bg-linear-to-b pointer-events-none absolute inset-0 rounded-[inherit] from-white/30 via-transparent to-white/10"
          aria-hidden="true"
        />
      </div>

      {/* Label */}
      <span
        className={`relative z-10 text-[14px]/[14px] font-medium ${comingSoon ? 'text-gray-75 dark:text-gray-30' : ''}`}
      >
        {comingSoon ? comingSoonText : children}
      </span>

      {/* Notify me button (coming soon state only) */}
      {comingSoon && (
        <div
          role="button"
          tabIndex={0}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            open('NOTIFY_ME', { excitedAbout });
          }}
          className="bg-gray-15 dark:bg-gray-90/50 hover:bg-gray-30 dark:hover:bg-gray-75 group-hover:bg-gray-30 dark:group-hover:bg-gray-75 relative z-10 flex h-[30px] cursor-pointer items-center rounded-lg px-3 pt-[0.15em] text-[12px]/[12px] font-medium transition-colors"
        >
          Notify me
        </div>
      )}
    </div>
  );
}
